import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";

import useNav from "core/hooks/useNav";
import api from "api";

import { useAuth } from "features/auth/fabric";


export const query = {
	get: (code) => ({
		queryKey: ["campaign", code],
		queryFn: () => api.campaign.get({ code }),
		enabled: !!code
	})
};

export const useQueryCampaign = () => {
	const params = useParams({ from: "/campaigns/$id" });
	return useSuspenseQuery(query.get(params.id));
};

export const useMutateCampaign = () => {
	const auth = useAuth();
	const nav = useNav();
	const params = useParams({ from: "/campaigns/$id" });

	return useMutation({
		mutationKey: ["redeem"],
		mutationFn: () => api.campaign.redeem({ code: params.id, device: auth.device }),
		onSuccess: () => nav.go({ to: "/", hash: params.id })
	});
};